module.exports = __webpack_public_path__ + "static/media/maxWave.e05b2632.svg";